<template>
  <div class="quota-message">
    <div class="quota-message__top">
      <div class="quota-message__top-image-wrap">
        <slot name="icon" />
      </div>
      <div>
        <div class="quota-message__head">
          <slot name="title" />
        </div>
        <slot name="subtitle" />
      </div>
    </div>
    <slot name="items" />
  </div>
</template>

<script>
export default {
  name: 'PaymentDashboardMessage',
};
</script>

<style lang="scss" scoped>
.quota-message {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 0, 0, 0.2);
  border-radius: 0.25rem;
  padding: 0.75rem 1.375rem 0.125rem 1.375rem;
  font-size: 0.875rem;
  line-height: 1.43;
  margin-top: 1.75rem;
  max-width: 100rem;
  &__top {
    display: flex;
    align-items: center;
    margin-bottom: 0.625rem;
  }
  &__top-image-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 3rem;
    width: 3rem;
    height: 3rem;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 50%;
    margin-right: 0.9375rem;
  }
  &__head {
    font-size: 1rem;
    line-height: 1.25;
    font-weight: 600;
    margin-bottom: 0.25rem;
  }
}

</style>
